export default __webpack_public_path__ + "static/media/BlogPic3.30997635.jpg";